(function() {
  // TODO refactor to i18n service or via moment localization support
  var DAYSOFWEEK = {
    1: 'monday',
    2: 'tuesday',
    3: 'wednesday',
    4: 'thursday',
    5: 'friday',
    6: 'saturday',
    0: 'sunday',
  };

  //exports
  window.DAYSOFWEEK = DAYSOFWEEK;
})();

(function() {
  // TODO refactor to i18n service or via moment localization support
  var MONTHOFYEAR = {
    0: 'january',
    1: 'february',
    2: 'march',
    3: 'april',
    4: 'may',
    5: 'june',
    6: 'july',
    7: 'august',
    8: 'september',
    9: 'october',
    10: 'november',
    11: 'december',
  };

  // exports
  window.MONTHOFYEAR = MONTHOFYEAR;
})();

(function() {
  // TODO Create service with async checks for local network and internet connection

  // import custom_alert from dialog

  function check_internet() {
    //TODO: можно реализовать посылкой запросов
    return true;
  }

  function require_internet() {
    if (check_internet()) {
      return true;
    } else {
      custom_alert(getlang('internet_required'));
      return false;
    }
  }

  // export
  window.check_internet = check_internet;
  window.require_internet = require_internet;
})();

(function() {
  // import lz from utils
  // todo refactor to moment format

  function toHHMMSS(secs, nostring) {
    var sec_num = parseInt(secs, 10); // don't forget the second param
    var sign, time;
    if (sec_num < 0) {
      sign = '-';
      sec_num = -sec_num;
    } else {
      sign = '';
    }
    var days = Math.floor(sec_num / (24 * 3600));
    var hours = lz(Math.floor((sec_num - days * 24 * 3600) / 3600));
    var minutes = lz(Math.floor((sec_num - days * 24 * 3600 - hours * 3600) / 60));
    var seconds = lz(sec_num - days * 24 * 3600 - hours * 3600 - minutes * 60);

    if (nostring) {
      time = minutes + ':' + seconds;
      if (days || hours | 0) {
        time = hours + ':' + time;
      }
      if (days) {
        time = days + 'd ' + time;
      }
    } else {
      time = minutes + 'm ' + seconds + 's';
      if (days || hours | 0) {
        time = hours + 'h ' + time;
      }
      if (days) {
        time = days + 'd ' + time;
      }
    }
    return sign + time;
  }

  // exports
  window.toHHMMSS = toHHMMSS;
})();

(function() {
  // TODO check if we need this still
  // refactor to performance checking service

  function perf(func, iterations) {
    if (typeof func != 'function') {
      func = perf1;
    }

    var starttime = Date.now();

    var act = '#messages';
    var to = '#138';

    var pages = ['#138', '#139'];
    var add = 1;
    var p = 0;

    for (var i = iterations | 0 || 1000; i > 0; i--) {
      func();
    }

    var time = Date.now() - starttime;

    return time;
  }

  function perfs(iterations) {
    var starttime = Date.now();

    if (!(iterations | 0)) {
      iterations = 0;
      //Определение количества итераций
      var threshold_time = 1000; //In ms
      var iterations_add = 100;

      //TODO: progressive iterations add
      while (Date.now() - starttime < threshold_time) {
        for (var i = iterations_add; i > 0; i--) {
          perf1();
        }
        iterations += iterations_add;
      }

      iterations = (iterations / 5) | 0;
      console.log('Test iterations: ' + iterations);
    }

    var time = 0;
    var min_time = Infinity;
    var tot_time = 0;
    var test_iter = 10;
    var avg_time = 0;
    var times1 = {cps: 0, per1000: 0};
    for (var o = 0; o < test_iter; o++) {
      time = perf(perf1, iterations);
      min_time = Math.min(min_time, time);
      tot_time += time;
      times1['t' + o] = time;
    }
    avg_time = (tot_time / test_iter / iterations) * 1000;
    times1.cps = ((iterations / (tot_time / test_iter)) * 1000) | 0;
    times1.per1000 = avg_time | 0;

    time = 0;
    min_time = Infinity;
    tot_time = 0;
    avg_time = 0;
    var times2 = {cps: 0, per1000: 0};
    for (var o2 = 0; o2 < test_iter; o2++) {
      time = perf(perf2, iterations);
      min_time = Math.min(min_time, time);
      tot_time += time;
      times2['t' + o2] = time;
    }
    avg_time = (tot_time / test_iter / iterations) * 1000;
    times2.cps = ((iterations / (tot_time / test_iter)) * 1000) | 0;
    times2.per1000 = avg_time | 0;

    console.table({'Func 1': times1, 'Func 2': times2});

    return (
      'P1 - avg:' +
      (avg_time | 0) +
      ' it:' +
      iterations +
      ' min:' +
      min_time +
      ' tot:' +
      tot_time +
      ' (' +
      (Date.now() - starttime) +
      ')'
    );
  }

  function perf1() {
  }

  function perf2() {
  }

  // export
  window.perfs = perfs;
})();

(function() {
  // TODO refactor to drawing service

  // import $

  function draw_point(x, y, color) {
    if (!color) {
      color = 'Red';
    }
    $(document.body).append(
      '<div class="draw_object" style="position:absolute;left:' +
      (x - 1) +
      'px;top:' +
      (y - 1) +
      'px;width:3px;height:3px;background-color:' +
      color +
      '"></div>',
    );
  }

  function draw_clear() {
    $('.draw_object').remove();
  }

  function draw_line(x1, y1, x2, y2) {
    var a = x1 - x2,
      b = y1 - y2,
      c = Math.sqrt(a * a + b * b);

    var sx = (x1 + x2) / 2,
      sy = (y1 + y2) / 2;

    var x = sx - c / 2,
      y = sy;

    var alpha = Math.PI - Math.atan2(-b, a);

    document.body.appendChild(createLineElement(x, y, c, alpha));
  }

  function createLineElement(x, y, length, angle) {
    var line = document.createElement('div');
    var styles =
      'border-top: 1px solid Red; ' +
      'width: ' +
      length +
      'px; ' +
      'height: 0px; ' +
      '-moz-transform: rotate(' +
      angle +
      'rad); ' +
      '-webkit-transform: rotate(' +
      angle +
      'rad); ' +
      '-o-transform: rotate(' +
      angle +
      'rad); ' +
      '-ms-transform: rotate(' +
      angle +
      'rad); ' +
      'position: absolute; ' +
      'top: ' +
      y +
      'px; ' +
      'left: ' +
      x +
      'px; ' +
      'z-index: 9999;';
    line.setAttribute('style', styles);
    line.setAttribute('class', 'draw_object');
    return line;
  }

  // export
  window.draw_point = draw_point;
  window.draw_clear = draw_clear;
  window.draw_line = draw_line;
})();

(function() {
  function matrixToArray(matrix) {
    var out;
    if (matrix.match(/^matrix3d\(/)) {
      out = matrix.substr(33, matrix.length - 34).split(', ');
    } else if (matrix.match(/^matrix\(/)) {
      out = matrix.substr(7, matrix.length - 8).split(', ');
    } else {
      out = [0, 0, 0, 0, 0, 0];
    }
    return out;
  }

  // exports
  window.matrixToArray = matrixToArray;
})();

(function() {
  // TODO refactor to using logger
  function l(obj) {
    console.log(obj);
  }

  // exports
  window.l = l;
})();

(function() {
  function fit_text(obj, min_size, force) {
    if (!min_size) {
      min_size = 8;
    }

    if (!obj.length) {
      return false;
    } else if (obj.length > 1) {
      obj.each(function() {
        fit_text($(this), min_size, force);
      });
      return false;
    }

    if (obj[0].textFited && !force) {
      return true;
    }

    obj[0].style.fontSize = '';

    //Новая реализация
    var style = getComputedStyle(obj[0]);
    var pad_left = parseInt(style.paddingLeft) | 0;
    var pad_right = parseInt(style.paddingRight) | 0;

    prepareItem(obj[0]);

    var scroll_width, offset_width;
    offset_width = obj[0].offsetWidth - pad_right - pad_left;

    if (offset_width < 0) {
      return restoreItem(obj[0]);
    }

    obj[0].style.width = 'auto';

    scroll_width = obj[0].offsetWidth;

    if (scroll_width > offset_width) {
      var tmp = parseInt(style.fontSize) | 0;
      var tmp_size = ((tmp * offset_width) / scroll_width) | 0;
      tmp_size = Math.min(tmp, Math.max(tmp_size, min_size));
      obj[0].style.fontSize = tmp_size + 'px';
    }

    restoreItem(obj[0]);
    obj[0].textFited = true;

    return true;
  }

  function prepareItem(item) {
    item.style.whiteSpace = 'nowrap';
    item.style.padding = '0';
  }

  function restoreItem(item) {
    item.style.whiteSpace = '';
    item.style.padding = '';
    item.style.width = '';
  }

  window.fit_text = fit_text;
})();

(function() {
  // TODO refactor to use of storage service

  // import storage

  function load_data() {
    var data = storage.getItem('data');
    if (data) {
      try {
        data = JSON.parse(data);
      } catch (e) {
        log.add('error parsing storage data');
        data = {};
      }
    } else {
      data = {};
    }
    return data;
  }

  function save_data(data) {
    return storage.setItem('data', JSON.stringify(data));
  }

  function clear_data() {
    return storage.setItem('data', JSON.stringify({}));
  }

  // exports
  window.load_data = load_data;
  window.save_data = save_data;
  window.clear_data = clear_data;
})();

(function() {
  // imports:
  // save_data, load_data, _tv_channels, tv_mosaic

  var first_channel = {
    set: function(num) {
      var storage_data = load_data();
      storage_data.first_channel = num;

      save_data(storage_data);
    },
    get: function() {
      var storage_data = load_data();
      var num = storage_data.first_channel ? storage_data.first_channel : 0;

      // if (_tv_channels[num]) {
      // 	if (_tv_channels[num].state == 'hide') {
      // 		num = get_visible_channel();
      // 	}
      // }
      // else {
      // 	num = get_visible_channel();
      // }

      return parseFloat(num);

      function get_visible_channel() {
        if (_tv_channels[0].state == 'show') {
          return 0;
        } else {
          window.tv_mosaic.current_channel = 0;
          return window.tv_mosaic.getIndex('up');
        }
      }
    },
  };

  // exports
  window.first_channel = first_channel;
})();

(function() {
  // import:
  // save_data
  // load_data
  // tv_channel_filter

  // сохранение гостевых установок фильтрации в tv_mosaic: language, category
  var filter_guest = {
    set: function(type, list) {
      var storage_data = load_data();
      storage_data['filter_' + type] = list;

      save_data(storage_data);
    },
    get: function(type) {
      var storage_data = load_data();

      if (storage_data['filter_' + type]) {
        return storage_data['filter_' + type];
      } else {
        return null;
      }
    },
    comparison: function(type, list) {
      var storage_list = load_data();
      var save_list = storage_list['filter_' + type];

      if (!save_list) {
        return;
      }
      if (save_list && list.length != save_list.length) {
        delete storage_list['filter_' + type];
        save_data(storage_list);
        return;
      }

      for (var i = 0; i < list.length; i++) {
        var key_list = Object.keys(list[i])[0];
        var key_save_list = Object.keys(save_list[i])[0];

        if (key_list == key_save_list) {
          list[i][key_list].selected = save_list[i][key_save_list].selected;
        } else {
          tv_channel_filter[type] = [];
          break;
        }

        if (list[i][key_list].selected) {
          tv_channel_filter[type].push(key_list);
        }
      }
    },
  };

  window.filter_guest = filter_guest;
})();

(function() {
  // TODO create separate service.
  //  Do not extend standard objects! In future versions of web standards it will be frozen and readonly.

  /**
   * Корректировка округления десятичных дробей.
   * расширения нативного метода Math
   *
   * @param {'round'|'floor'|'ceil'} type Тип корректировки.
   * @param {number} value Число.
   * @param {number} exp Показатель степени (десятичный логарифм основания корректировки).
   * @returns {number} Скорректированное значение.
   */
  function decimalAdjust(type, value, exp) {
    // Если степень не определена, либо равна нулю...
    if (typeof exp === 'undefined' || +exp === 0) {
      return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // Если значение не является числом, либо степень не является целым числом...
    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
      return NaN;
    }
    // Сдвиг разрядов
    value = value.toString().split('e');
    value = Math[type](+(value[0] + 'e' + (value[1] ? +value[1] - exp : -exp)));
    // Обратный сдвиг
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? +value[1] + exp : exp));
  }

  // Десятичное округление к ближайшему
  if (!Math.round10) {
    Math.round10 = function(value, exp) {
      return decimalAdjust('round', value, exp);
    };
  }
  // Десятичное округление вниз
  if (!Math.floor10) {
    Math.floor10 = function(value, exp) {
      return decimalAdjust('floor', value, exp);
    };
  }
  // Десятичное округление вверх
  if (!Math.ceil10) {
    Math.ceil10 = function(value, exp) {
      return decimalAdjust('ceil', value, exp);
    };
  }
})();

(function() {
  // imports $, load_data, save_data, get_hotelId
  // custom_dialog, getlang

  // TODO maybe refactor to pincode service?

  function pincode(text, length) {
    var data = load_data();
    if (data && data.pincode) {
      return data.pincode;
    }

    if (!text) {
      text = (get_hotelId() | 0) + '' + (storage.getItem('room') | 0);
    }

    if (!(length | 0)) {
      length = 4;
    }
    length = Math.min(8, length);

    var tmp = Math.PI;
    $(text.toString().split('')).each(function() {
      tmp = tmp / (((this | 0) + 1) * 0.99);
      if (tmp < 0.1) {
        tmp = tmp * 13;
      }
    });

    return tmp.toFixed(12).substr(-length);
  }

  function pincode_generate() {
    var data = load_data();
    data.pincode = Math.ceil(Math.random() * 8999 + 1000);
    save_data(data);

    //Вынести дилоговое окно во включние Parental Lock
    custom_dialog(
      'info',
      'PIN',
      getlang('pincode_remember') + '<br><div style="font-size:40px;text-align:center;">' + pincode() + '</div>',
    );
  }

  function pincode_reset() {
    var data = load_data();
    delete data.pincode;
    save_data(data);
    return true;
  }

  window.pincode = pincode;
  window.pincode_generate = pincode_generate;
  window.pincode_reset = pincode_reset;
})();

(function() {
  function $id(id) {
    return document.getElementById(id);
  }

  window.$id = $id;
})();

(function() {
  // import $, isset, tv_cur_block, tv_desktop_mark

  function clipper() {
    var tmp_image = $('#container')
      .css('background-image')
      .replace('url(', '')
      .replace(')', '')
      .replace(/\"/gi, '');
    var img = new Image();
    if (tmp_image && tmp_image !== 'none') {
      img.src = tmp_image;
    } else {
      // TODO handle this case
      log.add('clipper error: #container background-image set to "none"');
    }

    var storage_page = null;

    return function(elem, page) {
      console.log('clipper2', elem, page);
      if (tv_cur_block === 'VODplayer' || page === 'menu_wrapper' || tv_desktop_mark) {
        console.log('clip block');
        return false;
      }

      if (!elem) {
        document.getElementById('container').style.backgroundImage = '';
        // document.getElementById('menu_wrapper').style.backgroundImage = '';

        storage_page = null;

        // задержка делается для моделей Самсунг ЕЕ
        // в противном слумае подложка мигает
        setTimeout(function() {
          $.map($('#container canvas'), function(item) {
            if (item.getAttribute('id') === 'menu_wrapper_canvas') {
              item.style.display = 'none';
            } else {
              $(item).remove();
            }
          });
        }, 0);
      } else {
        var canvas = document.getElementById(page + '_canvas');

        if (!canvas) {
          renderCanvas(elem, page);
        } else if (storage_page !== page) {
          document.getElementById('container').style.backgroundImage = 'none';
          // document.getElementById('menu_wrapper').style.backgroundImage = 'none';
          document.body.style.backgroundImage = 'none';
          document.body.style.backgroundColor = 'transparent';
        }

        if (canvas && page === 'menu_wrapper') {
          document.getElementById('menu_wrapper_canvas').style.display = 'block';
        }

        if (tv_lg_mark) {
          elem.style.backgroundImage = 'url(tv:)';
        } else {
          elem.style.background = 'none';
        }
      }

      return true;

      function renderCanvas(_elem, _page) {
        storage_page = _page;

        $('#container').prepend(
          '<canvas id="' + _page + '_canvas" width=1280 height=720 style="position:absolute;top:0px;left:0px;">',
        );

        var ctx = document.getElementById(_page + '_canvas').getContext('2d');
        ctx.drawImage(img, 0, 0, 1280, 720);

        var tmp_rect = _elem.getBoundingClientRect();
        var top = Math.max(0, tmp_rect.top);
        var height = Math.max(0, tmp_rect.height);

        ctx.clearRect(tmp_rect.left, top, tmp_rect.width, height);

        setTimeout(function() {
          document.getElementById('container').style.backgroundImage = 'none';
          // document.getElementById('menu_wrapper').style.backgroundImage = 'none';
          document.body.style.backgroundImage = 'none';
          document.body.style.backgroundColor = 'transparent';
        }, 200);
      }
    };
  }

  window.clipper = clipper;
})();

(function() {
  // import tv_mag_mark, isset, tv_cur_block, active_page_id

  function isGetVideoPage() {
    var page = null;

    if (tv_mag_mark && !isset('config.tv.hacks.MAG')) {
      page = null;
      // TODO check this logic. This check makes no sense
    }

    if (
      tv_cur_block === 'menu' &&
      (isset('config.menu') === 'metro' || isset('config.menu') === 'scandic' || isset('config.menu') === 'custom')
    ) {
      page = 'menu_wrapper';
    } else {
      if (
        tv_cur_block === 'tv_channellist' ||
        tv_cur_block === 'category' ||
        tv_cur_block === 'language' ||
        tv_cur_block === 'channel' ||
        tv_cur_block === 'choosing_list' ||
        tv_cur_block === 'VODplayer' ||
        tv_cur_block === 'tv_radiolist' ||
        tv_cur_block === 'genre' ||
        tv_cur_block === 'mod_playlist' ||
        tv_cur_block === 'dialog' ||
        tv_cur_block === 'toppings' ||
        active_page_id === 'minibar' ||
        active_page_id === 'welcome' ||
        active_page_id === 'MOD' ||
        active_page_id === 'notification_container'
      ) {
        page = null;
      } else {
        page = active_page_id;
      }
    }

    return page;
  }

  // export
  window.isGetVideoPage = isGetVideoPage;
})();

(function() {
  function isStarOrEmoticon(element) {
    return element.parent().hasClass('stars') || element.parent().hasClass('emoticons');
  }

  // export
  window.isStarOrEmoticon = isStarOrEmoticon;
})();

(function() {
  // import is_saving_storage_process, log, _tv_channel_stop

  function reload_app(hardreset) {
    //TODO: переделать на промис сохранения
    if (is_saving_storage_process) {
      return setTimeout(function() {
        reload_app(hardreset);
      }, 200);
    }

    log.add('TV: reload app command');

    //Принудительный рестарт через 5 секунд
    setTimeout(function() {
      log.persistent.add('forced!', 'RELOAD');
      log.add('TV: FORCE RELOAD');
      document.location.reload(true);
    }, 5000);

    if (!hardreset) {
      _tv_channel_stop();
      Media.stop({directType: null}).done(function() {
        $('BODY>DIV').hide();
        setTimeout(function() {
          document.location.reload(true);
        }, 300);
      });
    } else {
      setTimeout(function() {
        document.location.reload(true);
      }, 300);
    }
  }

  window.reload_app = reload_app;
})();

(function() {
  // import Guest

  /**
   * Принимает фильм, категорию фильмов или канал
   * Если контент не надо показывать, возвращаем true
   * @param item - фильм, категория фильмов, каналов
   * @param direct - "video"
   * @returns {boolean}
   */
  function filterRightsContent(item, direct) {
    var types = item.contentTypes;
    if (!types || types.length === 0) {
      return false;
    }

    var rights;
    try {
      rights = Guest.rightsContent[direct];
    } catch (e) {
      return types.indexOf('pay') !== -1 || types.indexOf('xxx') !== -1;
    }

    switch (rights) {
      case 0:
        return false;
      case 1:
        return types.indexOf('pay') !== -1;
      case 2:
        return types.indexOf('xxx') !== -1;
      case 3:
        return true;
      default:
        return types.indexOf('pay') !== -1 || types.indexOf('xxx') !== -1;
    }
  }

  window.filterRightsContent = filterRightsContent;
})();

(function() {
  // import Guest, tv_cur_channel, getlang

  function handlerNopost(list, index, action) {
    var types = list[index].contentTypes;
    var nopost = false;

    if (!types || types.length === 0) {
      return action;
    }

    try {
      nopost = parseFloat(Guest.rightsContent.nopost);
    } catch (e) {
      return action;
    }

    if (nopost) {
      // если tv_cur_channel платный при nopost
      // сдвигаем канал вправо
      if ((list[index].type === 'ip' || list[index].type === 'rf') && tv_cur_channel == index) {
        tv_cur_channel++;
      }

      action =
        'custom_dialog(' +
        '\'alert\',' +
        ' \'' +
        getlang('tv_nottelevision') +
        '\',' +
        ' \'' +
        getlang('not_available_content') +
        '\'' +
        ')';
    }

    return action;
  }

  window.handlerNopost = handlerNopost;
})();

(function() {
  // import tv_manufacturer, tv_cur_block, $, active_page
  // TODO do we need this? Never used, seems this feature breaking something

  /**
   * Управление тенями на content_wrapper
   *
   * @param {object} data.to – если to есть, то к этому блоку добавляется нижняя тень,
   * передается из make_scroll
   * @param {number} data.shift, data.val – вычисляются в move_scroll
   * @param {object} data.scroll – передается из move_scroll
   *
   * @param {string} data.id – с какой страницы удалить
   * @param {boolean} data.remove – удалить тени
   *
   * */
  function manageShadowOnPage(data) {
    if (tv_manufacturer === 'tvip') {
      // добавление тени на TVip сильно все ломает
      return false;
    }

    if (tv_cur_block !== 'service_page' && tv_cur_block !== 'scroll' && tv_cur_block !== 'shopitem') {
      return;
    }

    if (typeof data.to !== 'undefined') {
      return data.to.find('.content_wrapper').addClass('bottom_shadow_mask');
    } else if (data.remove && tv_cur_block === 'shopitem') {
      return $('#' + data.id + ' .content_wrapper').removeClass('shadow_mask top_shadow_mask bottom_shadow_mask');
    }

    if (typeof data.shift === 'undefined' || typeof data.value === 'undefined' || typeof data.scroll === 'undefined') {
      return false;
    }

    var content_wrapper = $(active_page).find('.content_wrapper');
    if (data.shift === 0) {
      content_wrapper.removeClass('shadow_mask top_shadow_mask');
      content_wrapper.addClass('bottom_shadow_mask');
    } else if (data.value + 1 === data.scroll.max) {
      content_wrapper.removeClass('shadow_mask bottom_shadow_mask');
      content_wrapper.addClass('top_shadow_mask');
    } else if (!content_wrapper.hasClass('shadow_mask')) {
      content_wrapper.removeClass('top_shadow_mask bottom_shadow_mask');
      content_wrapper.addClass('shadow_mask');
    }
  }

  window.manageShadowOnPage = manageShadowOnPage;
})();

(function() {
  // import tv_cur_elem

  // CASE: SCANDIC_MENU
  // перемещаемся вправо со сдвигом меню влево и быстро нажимаем на лево
  // пока не закончилась анимация.
  // Это действие приводило к тому, что не правильно расчитывалось положение курсора
  var cursorMovingPermitted = {
    State: {},

    /**
     * @param {String} data.key - tv_cur_block
     * @param {String} data.direct - направление движения [top|right|bottom|left]
     * @param {Number} data.time - время анимации
     * @param {Boolean} data.animation - [true - анимация была | false - не было]
     * */
    set: function(data) {
      var state = this.State[data.key];
      if (typeof state !== 'undefined') {
        clearTimeout(state.timer);
      }

      this.State[data.key] = data;

      if (data.animation) {
        this.State[data.key].timer = setTimeout(
          function(_data) {
            this.State[_data.key].animation = false;
            $('.tv_cur').removeClass('tv_cur');
            tv_cur_elem.addClass('tv_cur');
          }.bind(this, data),
          data.time,
        );
      }
    },

    /**
     * @param {String} data.key - tv_cur_block
     * @param {String} data.direct - направление движения [top|right|bottom|left]
     * */
    get: function(data) {
      var state = this.State[data.key];

      if (typeof state === 'undefined' || !state.animation) {
        return true;
      }

      return state.direct === data.direct;
    },
  };

  window.cursorMovingPermitted = cursorMovingPermitted;
})();

(function() {
  // import tv_cur_block
  var previousPosition = {
    state: {},

    /**
     * Запоминаем позицию
     * */
    set: function(index, block) {
      block = previousPosition.getBlock(block);

      if (block !== 'menu' && block !== 'channel') {
        return false;
      }

      previousPosition.state[block] = index;

      return true;
    },

    /**
     * Отдаем сохраненную позицию
     * @param {string} block - tv_cur_block.
     * В случае, если block передан, но пользователь находится в другом tv_cur_block возвращает undefined
     * */
    get: function(block) {
      block = previousPosition.getBlock(block);
      return previousPosition.state[block];
    },

    /**
     * Особенность работы см. в описании previousPosition.get()
     * */
    getBlock: function(block) {
      return typeof block !== 'undefined' && block !== tv_cur_block ? undefined : tv_cur_block;
    },
  };

  window.previousPosition = previousPosition;
})();

(function() {
  function Running_string(target, speed, width) {
    var MARGIN = 20;

    this.timer = null;
    this.target = document.querySelector(target);
    this.width = this.target.clientWidth;
    this.speed = speed;
    this.content = this.target.innerHTML;
    this.wrapper = null;

    this.start = function() {
      _render.call(this, true);
      setTimeout(
        function() {
          _start.call(this, true);
        }.bind(this),
        500,
      );

      function _render(refresh) {
        if (refresh) {
          this.wrapper = document.createElement('span');
          this.wrapper.classList.add('wrapper_running_string');

          var inner_1 = document.createElement('span');
          inner_1.classList.add('inner_running_string');
          inner_1.innerHTML = this.content;
          var inner_2 = document.createElement('span');
          inner_2.classList.add('inner_running_string');
          inner_2.innerHTML = this.content;

          inner_1.style.transitionDuration = this.speed / 1000 + 's';
          inner_1.style.webkitTransitionDuration = +this.speed / 1000 + 's';
          inner_2.style.transitionDuration = +this.speed / 1000 + 's';
          inner_2.style.webkitTransitionDuration = +this.speed / 1000 + 's';

          inner_1.style.marginLeft = '0px';
          inner_2.style.marginLeft = '0px';
          inner_1.style.marginRight = MARGIN + 'px';
          inner_2.style.marginRight = MARGIN + 'px';

          this.wrapper.appendChild(inner_1);
          this.wrapper.appendChild(inner_2);

          this.target.innerHTML = '';
          this.target.appendChild(this.wrapper);
        } else {
          this.wrapper.firstElementChild.style.marginLeft = '0px';
          this.wrapper.appendChild(this.wrapper.firstElementChild);

          _start.call(this, false);
        }
      }

      function _start(init) {
        this.wrapper.firstElementChild.style.marginLeft = '-' + (this.width + MARGIN) + 'px';

        if (init) {
          this.timer = setInterval(_render.bind(this, false), this.speed);
        }
      }
    };
    this.stop = function() {
      clearInterval(this.timer);
      this.target.innerHTML = this.content;
    };
  }

  window.Running_string = Running_string;
})();

(function() {
  // TODO replace with template strings

  //printf
  String.prototype.format = function(args) {
    var newStr = this;
    for (var key in args) {
      newStr = newStr.replace('{' + key + '}', args[key]);
    }
    return newStr;
  };
})();

(function() {
  // import $

  /**
   * Предзагрузчик изображений
   *
   * @param {string} target - контейнер в котором ищем изображения и загружаем,
   * принимает "#id" и ".class"
   *
   * @param {function} [cb] – коллбек отображение прогресс бара загрузки изображений
   *
   */
  function PreloadMedia(target) {
    var Instance = this,
      d = $.Deferred();

    Instance.container = document.querySelector(__checkID(target));
    Instance.elements = Instance.container ? Instance.container.querySelectorAll('[image_url]') : [];

    if (!Instance.elements.length) {
      return d.resolve();
    }

    var i = Instance.elements.length;
    Instance.sources = [];
    while (i--) {
      Instance.sources.push(Instance.elements[i].getAttribute('image_url'));
    }

    new _PreloadMedia(Instance.sources)
      .progress(function(a, b) {
        d.notify(a, b);
      })
      .done(function() {
        __loadEnd();
      });

    return d.promise();

    function __loadEnd() {
      for (var j = 0; j < Instance.elements.length; j++) {
        var element = Instance.elements[j];
        const imageUrl = element.getAttribute('image_url');
        if (!imageUrl) {
          continue;
        }

        if (element.tagName.toLowerCase() !== 'img') {
          element.style.cssText = element.style.cssText.replace(
            'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=',
            imageUrl,
          );
        } else {
          element.setAttribute('src', imageUrl);
        }

        $(element).removeAttr('image_url');
      }
      d.resolve(Instance.sources.length);
    }

    // устранение ошибки поиска #Number
    // https://stackoverflow.com/questions/20306204/using-queryselector-with-ids-that-are-numbers
    function __checkID(_target) {
      if (_target.indexOf('#') === -1) {
        return _target;
      }

      var targetValue = _target.slice(1);
      if (isNaN(targetValue)) {
        return _target;
      }

      return '[id="' + targetValue + '"]';
    }
  }

  function _PreloadMedia(images) {
    var Instance = this,
      d = $.Deferred();

    Instance.loaded = 0;

    if (!images || !images.length) {
      return d.resolve();
    }

    Instance.sources = images;

    var length = Instance.sources.length,
      index = 0;

    var threads =
      isset('config.preload_images') === 1
        ? Instance.sources.length
        : isset('config.preload_threads')
          ? isset('config.preload_threads')
          : 1;

    while (threads--) {
      __load();
    }

    return d.promise();

    function __load() {
      var src = Instance.sources[index];
      index++;
      if (Instance.loaded < length) {
        if (index <= length) {
          var img = new Image();

          img.onload = function(_src) {
            Instance.loaded++;
            d.notify(Instance.loaded, length);
            __load();
          }.bind(null, src);

          img.onerror = function(_src) {
            Instance.loaded++;
            d.notify(Instance.loaded, length);
            __load();
            log.add('Preload: ERROR: Image load error ' + _src);
          }.bind(null, src);

          if (src) {
            img.src = src;
          } else {
            Instance.loaded++;
            d.notify(Instance.loaded, length);
            __load();
          }
        }
      } else {
        d.resolve();
      }
    }
  }

  // exports
  window.PreloadMedia = PreloadMedia;
  window._PreloadMedia = _PreloadMedia; // TODO check why private thing is used
})();

(function() {
  // TODO not used. CHeck if it is used for debug;

  function settings_fill() {
    if ($id('parental_lock_toggle')) {
      parental_lock_fill();
    }
  }

  // exports
  window.settings_fill = settings_fill;
})();

(function() {
  // optional import _tv_checkout, _deactivateChromecast, shop_clear
  // import Guest, storage, tv_channellist_type, tv_mosaic, clear_data (from utils)

  // private
  function tv_checkout() {
    if (window._tv_checkout && typeof window._tv_checkout == 'function') {
      window._tv_checkout();
    }
  }

  // private
  function deactivateChromecast() {
    if (window._deactivateChromecast && typeof window._deactivateChromecast === 'function') {
      window._deactivateChromecast();
    }
  }

  // private
  function _shop_clear() {
    if (window.shop_clear && typeof window.shop_clear === 'function') {
      window.shop_clear();
    }
  }

  function guestData_clear() {
    log.add('TV: cleared Guest data');

    Guest.clear_guest();

    // Compatibility (not used)
    storage.removeItem('guestName');
    storage.removeItem('guestTitle');
    storage.removeItem('surname');
    storage.removeItem('rightsContent');

    storage.removeItem('messages');
    storage.removeItem('message_unread');
    storage.removeItem('message_lastId');
    storage.removeItem('message_lasttime');
    //--------------

    storage.removeItem('token');
    storage.removeItem('wakeupMode');

    $('#messages_indicator').html(0).hide();
    $('.messages_group_indicator').html(0).hide();

    $('.in, .out, .date').remove();

    _shop_clear();

    if (isset('config.tv_channellist_type') === 'mosaic' && window.tv_mosaic && window.tv_mosaic.build) {
      window.tv_mosaic.toggle_filter_item();
      window.tv_mosaic.filter_channels();
      window.tv_mosaic.build_channel_list(true);
    }

    clear_data();

    tv_checkout();

    deactivateChromecast();
  }

  // exports
  window.guestData_clear = guestData_clear;
})();

(function() {
  // import getServerUrl

  /**
   * Modifies relative URLs to absolute URLs based on the server location.
   * If the URL is already absolute (starts with http, https, or udp), it is returned as is.
   *
   * @param {string} url - The relative or absolute URL.
   * @returns {string} The full absolute URL.
   */
  function setLocationURL(url) {
    if (!url.match(/^(https?|udp):\/\//gi)) {
      var link = getServerUrl().replace(/#(.+)/, '').split('/'); //удаление hash
      link.pop(); //удаление файла или пустого

      url = url.split('/');
      if (url[0] == '') {
        //абсолютный url
        link = link.slice(0, 3);
        url.shift();
      }

      url = link.concat(url).join('/');
    }

    return url;
  }

  // exports
  window.setLocationURL = setLocationURL;
})();

(function() {
  function encodeString(str) {
    if (str.indexOf('%') === -1) {
      return encodeURI(str);
    } else {
      return str;
    }
  }

  // exports
  window.encodeString = encodeString;
})();

(function() {
  // TODO move to Math extension service

  // ограничение числа отрезком
  Number.prototype.constrain = function(min, max) {
    return Math.max(min, Math.min(this, max));
  };
})();

(function() {
  // import $
  // TODO not used. Check if we need this for debug
  //  check perf and perfs functions in utils

  function perfomance_test() {
    $('*').each(function(d) {
      var that = this;
      var tmp = $(this).css('backgroundImage');

      if (tmp == 'none') {
        tmp = this.src;
        if (tmp) {
          tmp.match(/\/c\/i\//);
        }
      } else {
        tmp = tmp.match(/url\((.+\/c\/i\/.+)\)/);
        if (tmp) {
          tmp = tmp[1].split('"').join('');
        }
      }

      if (tmp) {
        //list.push(tmp.match(/url\((.+\/c\/i\/.+)\)/)[1].split('"').join(''))

        var im = new Image();
        im.onload = function() {
          //l(this.src);
          //TODO: сравнивать с размерами элемента 2х
          if (this.width > 640) {
            //l('w:' + this.width);
            log.add('Perf: ' + this.src + ', ' + this.width + 'px');
            $(that).css('outline', '1px solid Red');
          }
          if (this.height > 1200) {
            //l('h:' + this.height);
          }
        };
        im.onerror = function(_d) {
          l('error: ' + this.src);
        };
        im.src = tmp;
      }
    });
  }

  // exports
  window.perfomance_test = perfomance_test;
})();

(function() {
  // import isset, _tv_change_mute, tv_set_volume

  function tv_set_start_volume() {
    if (isset('config.tv.start_volume.enabled')) {
      _tv_change_mute(0);
      tv_set_volume(isset('config.tv.start_volume.volume'));
    }
  }

  // exports
  window.tv_set_start_volume = tv_set_start_volume;
})();

(function() {
  // import tv_sel_list, tv_cur_elem

  function select_item() {
    tv_sel_list.removeClass('selected');
    tv_cur_elem.addClass('selected');
  }

  // exports
  window.select_item = select_item;
})();

(function() {
  // import $, HotezaTV, log

  function show_splash() {
    $('#container').after('<div id="splashscreen"></div>');
    $('#splashscreen').show();
  }

  function delete_splash() {
    var splash = $('#splashscreen'),
      d = $.Deferred();

    deleteLoader();
    $('#tv_fullscreen_overlay').css('visibility', '');

    $(HotezaTV).trigger('splashout');

    if (splash.length) {
      splash.on(window.css_transitionend, function() {
        log.persistent.add('loaded', 'SYSTEM');
        log.add('Final');
        HotezaTV.metrics.final = time.uptime();
        $(HotezaTV).trigger('final');

        try {
          $(this).remove();
        } catch (e) {
          console.log('$(this).remove(); error');
        }

        d.resolve();
      });
      splash.addClass('hidden');
    } else {
      d.resolve();
    }

    return d.promise();
  }

  function deleteLoader() {
    $(document.body).removeClass('loading');
  }

  window.show_splash = show_splash;
  window.delete_splash = delete_splash;
})();

(function() {
  // todo now used only in Wakeupcall
  // import $

  function deleteFeaturesSubstrate(target) {
    $('#' + target + ' #features_substrate').remove();
  }

  window.deleteFeaturesSubstrate = deleteFeaturesSubstrate;
})();

(function() {
  // todo move to jquery extensions
  // import $

  // Глобальная установка таймаута 10 сек
  $.ajaxSetup({
    timeout: 10000, //Time in milliseconds
  });

  //Глобальное снижение качество эффектов jquery
  $.fx.interval = 50;
})();

(function() {
  // import jQuery

  // TODO move to Jquery extensions file

  jQuery.cachedScript = function(url, options) {
    // Allow user to set any option except for dataType, cache, and url
    options = $.extend(options || {}, {
      dataType: 'script',
      cache: true,
      url: url,
    });

    // Use $.ajax() since it is more flexible than $.getScript
    // Return the jqXHR object so we can chain callbacks
    return jQuery.ajax(options);
  };
})();

(function() {
  // import $

  // todo not used anywhere. Check if we need it for debug.

  /**
   * Gets all event-handlers from a DOM element.
   * Events with namespace are allowed.
   *
   * @param  {Element} node: DOM element
   * @param  {String} eventns: (optional) name of the event/namespace
   * @return {Object}
   */
  function getEventHandlers(element, eventns) {
    var $ = window.jQuery;
    var i = (eventns || '').indexOf('.'),
      event = i > -1 ? eventns.substr(0, i) : eventns,
      namespace = i > -1 ? eventns.substr(i + 1) : void 0,
      handlers = Object.create(null);
    element = $(element);
    if (!element.length) {
      return handlers;
    }
    // gets the events associated to a DOM element
    var listeners = $._data(element.get(0), 'events') || handlers;
    var events = event ? [event] : Object.keys(listeners);
    if (!eventns) {
      return listeners;
    } // Object with all event types
    events.forEach(function(type) {
      // gets event-handlers by event-type or namespace
      return (listeners[type] || []).forEach(getHandlers, type);
    });

    // eslint-disable-next-line
    function getHandlers(e) {
      var type = this.toString();
      var eNamespace = e.namespace || (e.data && e.data.handler);
      // gets event-handlers by event-type or namespace
      if (
        (event === type && !namespace) ||
        (eNamespace === namespace && !event) ||
        (eNamespace === namespace && event === type)
      ) {
        handlers[type] = handlers[type] || [];
        handlers[type].push(e);
      }
    }

    return handlers;
  }

  window.getEventHandlers = getEventHandlers;
})();

(function() {
  // TODO move to channel service
  // import getChannels tv_channel_filter tv_channel_categories _tv_channels tv_channels Events

  /**
   * @param id - id канала
   * @returns {number} - индекс канала в списке каналов
   * */
  function getChannelIndexById(id) {
    var index,
      channels = getChannels();

    for (var i = 0; i < channels.length; i++) {
      var item = channels[i];
      if (id === item.id) {
        index = i;
        break;
      }
    }

    return index;
  }

  /**
   * @param id - id канала
   * @returns {object} - канал
   * */
  function getChannelById(id) {
    var index,
      channels = getChannels();

    for (var i = 0; i < channels.length; i++) {
      var item = channels[i];
      if (id === item.id) {
        index = i;
        break;
      }
    }

    return channels[index];
  }

  function channelCategories(channel, _channelCategories) {
    if (channel.category && _channelCategories.indexOf(channel.category) === -1) {
      _channelCategories.push(channel.category);
    }
  }

  channelCategories.addFilter = function(categoryIndex) {
    var filters = channelCategories.getFiltersList();
    filters.push(categoryIndex);
  };
  channelCategories.removeFilter = function(categoryIndex) {
    var filters = channelCategories.getFiltersList();
    for (var i = 0; i < filters.length; i++) {
      var filter = filters[i];
      if (filter == categoryIndex) {
        filters.splice(i, 1);
        break;
      }
    }
  };
  channelCategories.getFiltersList = function() {
    if (typeof tv_channel_filter === 'undefined') {
      window.tv_channel_filter = {};
    }
    if (typeof tv_channel_filter.category === 'undefined') {
      tv_channel_filter.category = [];
    }

    return tv_channel_filter.category;
  };
  channelCategories.getNamesFiltersList = function(allNames) {
    var filters = channelCategories.getFiltersList(),
      results = [];

    if (tv_channel_categories.length === 0) {
      return results;
    }

    if (allNames) {
      return tv_channel_categories;
    }

    for (var i = 0; i < filters.length; i++) {
      var filter = filters[i];
      results.push(tv_channel_categories[filter]);
    }

    return results;
  };
  channelCategories.hasFilter = function(index) {
    index = parseInt(index);
    var filters = channelCategories.getFiltersList();
    return filters.indexOf(index) !== -1;
  };

  function getChannels() {
    //TODO: выпилить это
    return typeof _tv_channels !== 'undefined' ? _tv_channels : tv_channels;
  }

  // private
  function getFiltratedChannelList() {
    var filterList = channelCategories.getNamesFiltersList(),
      channels = getChannels(),
      result = [];

    if (filterList.length === 0) {
      return channels;
    }

    for (var i = 0; i < channels.length; i++) {
      var channel = channels[i];
      if (filterList.indexOf(channel.category) !== -1) {
        result.push(channel);
      }
    }

    return result;
  }

  //TODO: убрать в RemoteControl
  //TODO: переделать схему синхронизации списка
  function sendChannelsToMobile() {
    var channels = getFiltratedChannelList();
    var out_array = [];
    for (var o in channels) {
      var ch = channels[o];
      out_array.push({
        id: ch.id,
        name: ch.name,
        image: ch.image,
        state: ch.state,
        epg: ch.epg,
        categories: ch.categories,
        language: ch.language,
      });
    }
    Events.send('set_channels', out_array);
  }

  function sendChannelId(id) {
    Events.send('set_channel', id);
  }

  window.getChannelIndexById = getChannelIndexById;
  window.getChannelById = getChannelById;
  window.channelCategories = channelCategories;
  window.getChannels = getChannels;
  window.sendChannelsToMobile = sendChannelsToMobile;
  window.sendChannelId = sendChannelId;
})();

(function() {
  // import
  // navigate
  // getlang
  // isset
  // Services
  // parental_lock_status
  // pincode
  // tv_room

  var informationPage = {
    page: null,
    state: {},
    Dict: {
      pa: 'product_added',
      dt: 'delivery_time',
      sp: 'success_shop', // вообще-то это success_product
      ss: 'success_service',
      sw: 'success_wakeup',
      cp: 'confirmation_page',
      qr: 'qr_paywall',
    },
    /**
     * Открытие информационной страницы.
     *
     * @param {Object} data - контекст (данные).
     * @param {string} data.type - sp = success_product,
     *                             ss = success_service,
     *                             dt = delivery_time,
     *                             pa = product_added,
     *                             cp = confirmation_page
     *                             sw = success_wakeup
     * @param {string} [data.back] - куда возвращаемся. Полезно для type === 'delivery_time'
     * @param {number} [data.approxTime] - примерное время выполнения заказа
     *
     * Используется в type === confirmation_page
     * @param {function} [data.onConfirm] - ф-ия выполняется, если прошла валидация вводимых данных
     * @param {function} [data.onError] – ф-ия выполняется, если валидация вводимых данных не прошла
     */
    open: function(data) {
      informationPage.render(data);
      navigate('#information', null, true);
    },
    onClose: function () {
      $('#information').hide();
    },
    render: function (data) {
      data = getData(data);

      this.state = data;

      var html = templates_cache['information'].render(data);

      if (!informationPage.page) {
        document.getElementById('container').insertAdjacentHTML('beforeend', html);
        informationPage.page = document.getElementById('information');
        informationPage.page.setAttribute('onclose', 'informationPage.onClose();');
      } else {
        informationPage.page.innerHTML = '';
        informationPage.page.insertAdjacentHTML('beforeend', html);
      }

      function getData(_data) {
        if (typeof _data === 'undefined' || typeof _data.type === 'undefined') {
          _data = {type: 'pa'};
        }

        if (!informationPage.page) {
          _data.firstInit = true;
        }
        if (_data.approxTime) {
          _data.approximate_text = getlang('approximate_time');
        }

        _data.title = getTitle(_data);
        _data.content = getContent(_data);
        _data.lang = {
          back: getlang('mobileAppContent-default-label-back'),
        };

        _data.backBtn = 1;
        _data.onvclick =
          typeof _data.back === 'undefined' ? 'navigate(HotezaTV.history.lastpage, \'back\');' : _data.back;

        if (_data.type === 'cp') {
          _data.onvclick += '$(\'#information .content_wrapper\').remove();';
        }

        return _data;
      }

      function getContent(_data) {
        var text = isset('structv2.config.' + informationPage.Dict[_data.type] + '.text'),
          textTooltip = isset('structv2.config.' + informationPage.Dict[_data.type] + '.text_tooltip'),
          textError = isset('structv2.config.' + informationPage.Dict[_data.type] + '.text_error');

        switch (_data.type) {
          case 'pa':
            return {
              text: text ? text : getlang('product_added_text'),
              buttons: [
                {
                  type: 'onvclick',
                  translate: getlang('mobileAppContent-mainContent-button-continueshopping'),
                  action: 'navigate(\'#' + Services.shopId + '\')',
                },
                {
                  type: 'href',
                  translate: getlang('mobileAppContent-mainContent-button-gotocart'),
                  action: '#cart',
                },
              ],
            };

          case 'dt':
            var order = Services.getOrders('not_placed', _data.orderId);
            return {
              text: text ? text : getlang('mobileAppContent-mainContent-label-shopordertext'),
              buttons: _data.isService
                ? [
                  {
                    type: 'onvclick',
                    translate: getlang('mobileAppContent-mainContent-select-deliverOrder-now'),
                    action: 'service_post(\'' + _data.orderId + '\', \'now\');',
                  },
                  {
                    type: 'onvclick',
                    translate: getlang('mobileAppContent-contentPage-input-hotelServiceRequest-selectTime'),
                    action:
                      'time_picker.open(HotezaTV.history.lastpage, \'service_post(\\\'' +
                      _data.orderId +
                      '\\\', $(this).attr(\\\'time\\\'))\')',
                  },
                ]
                : [
                  {
                    type: 'onvclick',
                    translate: getlang('mobileAppContent-mainContent-select-deliverOrder-now'),
                    action: 'shop_order(\'now\', \'' + _data.orderId + '\');',
                  },
                  {
                    type: 'onvclick',
                    translate: getlang('mobileAppContent-contentPage-input-hotelServiceRequest-selectTime'),
                    action:
                      'time_picker.open(\'#orders\', \'shop_order($(this).attr(\\\'time\\\'), \\\'' +
                      _data.orderId +
                      '\\\')\', ' +
                      (order && order[Services.shopId] ? order[Services.shopId].approxTime | 0 : 0) +
                      ')',
                  },
                ],
            };

          case 'sp':
            return {
              text: text ? text : getlang('success_product_text'),
              approxTime: _data.approxTime,
              buttons: [
                {
                  type: 'onvclick',
                  translate: getlang('back_to_menu'),
                  action: 'navigate(\'#menu\');',
                },
                {
                  type: 'href',
                  translate: getlang('my_orders'),
                  action: '#orders',
                },
              ],
            };

          case 'ss':
            return {
              text: text ? text : getlang('success_service_text'),
              approxTime: _data.approxTime,
              buttons: [
                {
                  type: 'onvclick',
                  translate: getlang('back_to_menu'),
                  action: 'navigate(\'#menu\');',
                },
                {
                  type: 'href',
                  translate: getlang('my_orders'),
                  action: '#orders',
                },
              ],
            };

          case 'sw':
            return {
              text: text ? text : getlang('success_service_text'),
              approxTime: _data.approxTime,
              buttons: [
                {
                  type: 'onvclick',
                  translate: getlang('back_to_menu'),
                  action: 'navigate(\'#menu\');',
                },
                {
                  type: 'href',
                  translate: getlang('my_orders'),
                  action: '#orders',
                },
              ],
            };

          case 'cp':
            var isPinCode = isset('config.tv.parental_lock') && parental_lock_status(),
              action =
                'custom_input_check(' +
                '$(\'#custom_dialog_input\').html(), ' +
                '\'' +
                _data.onConfirm +
                '\', ' +
                '\'' +
                _data.onError +
                '\'' +
                ');';

            return {
              text: text ? text : getlang('confirmation_page_text'),
              textTooltip: textTooltip ? textTooltip : getlang('confirmation_page_text_tooltip'),
              textConfirm: isPinCode ? getlang('confirmation_page_pin_code') : getlang('confirmation_page_room_number'),
              textError: textError ? textError : getlang('confirmation_page_text_error'),
              check: isPinCode ? pincode() : tv_room,
              buttons: [
                {
                  type: 'onvclick',
                  translate: getlang('confirm'),
                  action: action,
                  onvmove: 'blinkedCursor.off(document.querySelector(\'#information .input\'))',
                },
              ],
            };

          case 'qr':
            return {
              text: isset('structv2.config.payQR.text'),
              qrBlobUrl: _data.qrBlobUrl,
              buttons: [
                {
                  type: 'onvclick',
                  translate: getlang('cancel'),
                  action: 'navigate(\'#menu\')',
                },
              ],
            };
        }
      }

      function getTitle(_data) {
        var title = isset('structv2.config.' + informationPage.Dict[_data.type] + '.title');

        switch (_data.type) {
          case 'pa':
            return title ? title : getlang('product_added_header');

          case 'dt':
            return title ? title : getlang('delivery_time_header');

          case 'sp':
            return title ? title : getlang('success_product_header');

          case 'ss':
            return title ? title : getlang('success_service_header');

          case 'sw':
            return title ? title : getlang('success_service_header');

          case 'cp':
            return title ? title : getlang('confirmation_page_header');

          case 'qr':
            return title ? title : isset('structv2.config.payQR.title');
        }
      }
    },
  };

  window.informationPage = informationPage;
})();

(function() {
  // import isset, css_append
  /**
   * Для работы объекту требуется контейнер в который добавляется курсор
   * Также контейнер должен сожержать блок #custom_dialog_input
   * */
  var blinkedCursor = {
    timer: null,
    on: function(container) {
      var _blinkedCursor = container.querySelector('#blinked_cursor');
      if (!_blinkedCursor) {
        clearTimeout(this.timer);
        createCursor(container);
      }

      this.blinking(container);

      function createCursor(_container) {
        _container
          .querySelector('#custom_dialog_input')
          .insertAdjacentHTML('afterend', '<div id="blinked_cursor"></div>');
      }
    },
    off: function(container) {
      clearTimeout(blinkedCursor.timer);
      container.querySelector('#blinked_cursor').classList.add('cursor_invisible');
    },
    blinking: function(container) {
      clearTimeout(blinkedCursor.timer);

      var cursor = container.querySelector('#blinked_cursor');
      if (!cursor) {
        return false;
      }

      cursor.classList.toggle('cursor_invisible');

      blinkedCursor.timer = setTimeout(blinkedCursor.blinking.bind(null, container), 900);
    },
  };

  function cursorAnimation() {
    if (!isset('config.tv.cursor_animation') || isset('config.menu') === 'classic' || isset('config.menu') === '') {
      return false;
    }

    css_append('s/cursor-animation.css');
  }

  // export
  window.blinkedCursor = blinkedCursor;
  window.cursorAnimation = cursorAnimation;
})();

(function() {
  // import lz

  function generate_uuid(withoutColon) {
    var tmp = lz(((Math.random() * 255) | 0).toString(16));
    for (var i = 0; i < 5; i++) {
      tmp += (withoutColon ? '' : ':') + lz(((Math.random() * 255) | 0).toString(16));
    }
    return tmp;
  }

  //export
  window.generate_uuid = generate_uuid;
})();

(function() {
  function hex2a(hexx) {
    var hex = hexx.toString(); //force conversion
    var str = '';
    for (var i = 0; i < hex.length; i += 2) {
      str += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
    }
    return str;
  }

  function a2hex(string) {
    var hex = '';
    for (var i = 0; i < string.length; i++) {
      hex += string.charCodeAt(i).toString(16);
    }
    return hex;
  }

  window.hex2a = hex2a;
  window.a2hex = a2hex;
})();

(function() {
  // todo move to style service

  function hexToRGB(hex, alpha) {
    var r = parseInt(hex.slice(1, 3), 16),
      g = parseInt(hex.slice(3, 5), 16),
      b = parseInt(hex.slice(5, 7), 16);

    if (alpha) {
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    } else {
      return 'rgb(' + r + ', ' + g + ', ' + b + ')';
    }
  }

  window.hexToRGB = hexToRGB;
})();

(function() {
  // import log, handleSelectableNavigation

  /**
   * Ф-ия выполнения действии по открытию/закрытию страницы
   *
   * @param {object} page - jQuery объект страницы
   * @param {string} type - close | open
   * */
  function execAction(page, type) {
    if (!page || !page.length) {
      return false;
    }

    var actions = getActions(page, type, []);
    if (actions.length === 0) {
      return false;
    }

    try {
      for (var i = 0; i < actions.length; i++) {
        // eslint-disable-next-line no-eval
        eval(actions[i]); //jshint ignore: line
      }
    } catch (e) {
      log.add('NAV: on' + type + ' error: ' + e);
    }

    function getActions(page, type, actions) {
      if (page.length === 0) {
        return actions;
      }

      var action = page[0].getAttribute('on' + type);
      if (action) {
        actions.push(action);
      }

      page = page.find('[on' + type + ']');
      return getActions(page, type, actions);
    }
  }

  /**
   * Executes code from onUp, onDown, onLeft or onRight attributes depending on passed direction
   * @param direction {'up' | 'down' | 'left' | 'right'}
   * @param $element
   */
  function execDirectionAction(direction, $element) {
    var directionToActionMap = {
      up: 'onUp',
      down: 'onDown',
      left: 'onLeft',
      right: 'onRight',
    };
    var action = $element.attr(directionToActionMap[direction]);
    if (!action) {
      handleSelectableNavigation(direction);

      return;
    }

    eval(action);
  }

  window.execAction = execAction;
  window.execDirectionAction = execDirectionAction;
})();

(function() {
  // TODO move to jquery extensions

  window.jQuery.fn.extend({
    cycleClass: function(classes) {
      var classes_arr = classes.split(' ');
      return this.each(function() {
        var tmp = -1;
        for (var i in classes_arr) {
          if ($(this).hasClass(classes_arr[i])) {
            tmp = i;
          }
        }

        tmp++;
        if (tmp >= classes_arr.length) {
          tmp = 0;
        }

        $(this).removeClass(classes);
        $(this).addClass(classes_arr[tmp]);
      });
    },
  });
})();

(function() {
  // import Epg

  function isEpgFirstLine() {
    if (typeof Epg === 'undefined') {
      return false;
    }

    return Epg.isFirstLine();
  }

  window.isEpgFirstLine = isEpgFirstLine;
})();

(function() {
  // todo refactor to server command service

  // import log, $

  /**
   * Ф-ия получения команд от сервера
   * @param {object} data - данные
   * @param {object} data.payload - данные для запроса
   * @param {string} [data.payload.token] - токен пользователя
   * @param {string} [data.payload.cmd] - имя запрашиваемой команды используется когда хотим получить данные конкретной
   *   команды
   * @param {string} [data.url] - запрашиваемый url
   * @param {string} [data.method] - HTTP метод
   *
   * @param {object} [options] - используется для передачи дополнительных параметров, например contentType
   *
   * @returns {object}
   * @example
   * ```
   * {
   *   result: 0,
   *   message: 'OK',
   *   payload: [
   *     {
   *       cmd: 'feedback',
   *       data: {
   *         showAlert: true,
   *       },
   *     },
   *   ],
   * }
   * ```
   * @example коды ответа r.result
   *    0 - успех
   *    1 - некорректные входные данные
   *    2 - некорректный токен
   *    3 - гость выселен
   *    4 - гость отменён (по сути выселен, рудимент со старых времён)
   */
  function getServerCommandsAsync(data, options) {
    var d = $.Deferred(),
      url = data.url ? data.url : isset('config.admin_url') + 'jsonapi/getTask';

    if (!url) {
      log.add('GET CMD: url not exists');
      return d.reject();
    }

    $.ajax(
      Object.assign(
        {
          url: url,
          method: data.method ? data.method : 'POST',
          data: data.payload,
          success: defaultResponseHandler('getServerCommandsAsync', function(r) {
            if (r.result === 0) {
              return d.resolve(r.payload || r.data);
            }

            log.add('GET CMD: ERROR: ' + r.message);
            d.reject(r.message);

            return false;
          }),
          error: function(xhr, error) {
            log.add('GET CMD: network error');
            return d.reject('network error');
          },
        },
        options,
      ),
    );

    return d.promise();
  }

  /**
   * @param {string} [name] - имя ф-ии
   * @param {function} [handler] - ф-ия обработчик. Должна вернуть true, если ответ обработан.
   * */
  function defaultResponseHandler(name, handler) {
    name = name ? name : 'Default';
    handler = handler
      ? handler
      : function() {
        return false;
      };

    return function(res) {
      if (handler(res)) {
        return true;
      }

      /**
       * 0 - успех
       * 100 - успех, повторый заказ
       *
       * 1 - некорректные данные
       * 2 - некоректный токен
       * 3 - гость выселен или не существует
       * 9 - exception
       * */
      switch (res.result) {
        case 0:
          log.add('GET CMD: ResHandler ' + name + ': ok');
          return true;
        case 1:
          log.add('GET CMD: ResHandler ' + name + ': incorrect data');
          break;
        case 2:
          log.add('GET CMD: ResHandler ' + name + ': incorrect token');
          break;
        case 3:
          log.add('GET CMD: ResHandler ' + name + ': guest was checked out or doesn\'t exist');
          break;
        case 9:
          log.add('GET CMD: ResHandler ' + name + ': server error');
          break;
        default:
          log.add('GET CMD: ResHandler ' + name + ': unknown answer');
          break;
      }

      // выполняется если от сервера получен ответ отличный от 0
      log.add('GET CMD: ResHandlerError ' + name + ': ' + res.message);
    };
  }

  /**
   * Ф-ия получающая команду из списка команд по имени
   * @param {string} cmd - имя команды
   * @param {array} list - список команд
   * @returns { object | null }
   * */
  function getCommandFromList(cmd, list) {
    if (!cmd || !list) {
      return null;
    }

    for (var i = 0; i < list.length; i++) {
      var listElement = list[i];
      if (listElement.cmd === cmd) {
        return listElement;
      }
    }

    return null;
  }

  window.getServerCommandsAsync = getServerCommandsAsync;
  window.getCommandFromList = getCommandFromList;
})();

(function() {
  // import $, $id

  // todo create service for dynamic work with css

  function css_append(link, id) {
    if ($('#' + id).length) {
      return false;
    }

    link += version ? '?v=' + version.v : '?_noversion';

    link =
      typeof id !== 'undefined'
        ? '<link id="' + id + '" href="' + link + '" rel="stylesheet" type="text/css">'
        : '<link href="' + link + '" rel="stylesheet" type="text/css">';

    if ($id('customization_css')) {
      $('#customization_css').before(link);
    } else {
      $(document.head).append(link);
    }
  }

  function css_inject(css) {
    $('<style></style>').prop('type', 'text/css').html(css).appendTo('head');
  }

  window.css_append = css_append;
  window.css_inject = css_inject;
})();

(function() {
  function getKeyCode(e) {
    if (!e) {
      e = event;
    }
    var code = e.keyCode ? e.keyCode : e.which;

    //Обработка shift для MAG
    if (e.shiftKey) {
      code = 'S' + code;
    }

    return code;
  }

  window.getKeyCode = getKeyCode;
})();

(function() {
  // import move_scroll
  /**
   * @param {object} elem - элемент к которому перемещаемся
   * @param {number} offset - сдвиг относительно вычисляемого значения,
   *                          чтобы эл-т был не в самом вверху, а чуть ниже
   * @param {object} [content] - .content
   * @param {object} [wrapper] - .content_wrapper
   * */
  function goToElement(elem, offset, content, wrapper) {
    if (!elem) {
      return false;
    }

    content = content ? content : elem.closest('.content');
    wrapper = wrapper ? wrapper : elem.closest('.content_wrapper');
    offset = offset ? offset : 0;

    if (!content || !wrapper) {
      return false;
    }

    var shiftElem = elem.getBoundingClientRect().top,
      shiftContent = !!parseInt(content.style.top) ? parseInt(content.style.top) : 0,
      shiftWrapper = wrapper.getBoundingClientRect().top;

    var shift = shiftElem - shiftWrapper;
    content.style.top = shiftContent - shift + offset + 'px';

    move_scroll(parseInt(content.style.top));
  }

  window.goToElement = goToElement;
})();

(function() {
  // todo move to Modules
  function deleteDisableModulesFromList(list) {
    var disable_modules = isset('config.tv.hacks.disable_modules');
    if (disable_modules && disable_modules.length) {
      for (var i = 0; i < disable_modules.length; i++) {
        var disable_module = disable_modules[i],
          index = list.indexOf(disable_module);

        if (index !== -1) {
          list.splice(index, 1);
        }
      }
    }

    return list;
  }

  window.deleteDisableModulesFromList = deleteDisableModulesFromList;
})();

(function() {
  var Cache = function() {
    this.cache = {};

    this.hasItem = function(key) {
      return !!this.cache[key];
    };

    this.setItem = function(key, data) {
      return (this.cache[key] = data);
    };

    this.getItem = function(key) {
      return this.cache[key];
    };

    this.deleteItem = function(key) {
      return delete this.cache[key];
    };
  };

  window.Cache = Cache;
})();

(function() {

  /**
   * Get values of object
   * @param {Record<string, *>} obj
   * @return {*[]}
   * @deprecated replace with Object.values(obj)
   */
  function objectToArrayList(obj) {
    var arr = [];
    for (var key in obj) {
      if (obj[key] === true) {
        continue;
      }
      arr.push(obj[key]);
    }
    return arr;
  }

  window.objectToArrayList = objectToArrayList;
})();

(function() {
  // import $, isset, getServerCommandsAsync, GibberishAES get_hotelId storage log getPageFromStruct getPageFromStruct
  // getRcuPageFromStruct getParent TODO: ужс, переделать на модуль
  var QR = {
    //TODO: почистить после удаления YandexStation
    /**
     * @param id - id пункта меню или страницы
     * @param type - тип [menu, page]
     * @param [payload] - данные для формирования uri
     * @param [apiUri] - метод по которому обращаемся к серверу за QR'ом
     * */
    get: function(id, type, payload, apiUri) {
      if (typeof id === 'object') {
        for (var key in id) {
          var item = id[key];
          if (item.type === 'authQR') {
            QR.get(item.id, 'menu', item.payload);
          }
        }

        return false;
      }

      var apiUrl = isset('config.admin_url') + (apiUri || 'jsonapi/getAuthTag');

      getServerCommandsAsync(
        {
          url: apiUrl,
          method: 'POST',
          payload: JSON.stringify({
            sign: GibberishAES.enc(get_hotelId(), isset('config.secret')),
            hotelId: get_hotelId(),
            token: storage.getItem('token'),
            uri: QR.getUri(id, type, payload),
            base64: true,
          }),
        },
        {contentType: 'application/json'},
      )
        .done(function(r) {
          QR.handlerSuccess(
            Object.assign(
              {
                id: id,
                type: type,
              },
              r,
            ),
          );
        })
        .fail(function(err) {
          QR.handlerError(Object.assign({type: type}, err));
          log.add('QR: get error: ' + err);
        });
    },

    getUri: function(id, type, payload) {
      payload = typeof payload === 'undefined' ? getPageFromStruct(id).payload : payload;
      if (payload.link) {
        var to = getPageFromStruct(payload.link);
        to = to.type ? to : getRcuPageFromStruct(payload.link);
        switch (to.type) {
          case 'page':
            return '/page/' + to.parentId + '/?modalType=page&modalId=' + to.id;

          case 'shopProduct':
            return '/page/' + getParent(to, 2).id + '/?modalType=page&modalId=' + to.id;

          case 'hotezaremote':
            return '/hotezaremote';

          default:
            return '/page/' + to.id;
        }
      }

      return '';
    },

    render: function(payload) {
      switch (payload.type) {
        case 'menu':
          $('[data-id="' + payload.id + '"]').css('background-image', 'url(' + payload.qrCode + ')');
          break;

        default:
          $('#' + payload.id + ' .wrap_img').css('background-image', 'url(' + payload.qrCode + ')');
          break;
      }
    },

    handlerSuccess: function(payload) {
      QR.render({
        id: payload.id,
        type: payload.type,
        qrCode: payload.qrCode,
      });
    },

    handlerError: function(r) {
      //custom_alert(r.message);
      log.add('QR: getAuthTag error: ' + r.message);
    },
  };

  window.QR = QR;
})();

(function() {
  // promise extensions

  /**
   * Поочерёдное выполнение promise
   * @param {array} functions_array - Массив функций, возвращающих promise
   * @returns {promise}
   */
  function chain_promises(functions_array) {
    var _d = $.Deferred();
    var chained_promise = _d.promise();
    for (var index in functions_array) {
      chained_promise = _nest_promise(chained_promise, index);
    }

    var d = $.Deferred();
    var returns = [];

    chained_promise.done(function(data) {
      returns.shift();
      returns.push(data);
      d.resolve(returns);
    });

    _d.resolve();

    return d.promise();

    function _nest_promise(promise, _index) {
      return promise.then(function(data) {
        d.notify(((1 + parseInt(_index)) / functions_array.length).toFixed(2));
        returns.push(data);
        return functions_array[_index]();
      });
    }
  }

  function sleep(ms) {
    var dfd = $.Deferred();

    setTimeout(function() {
      dfd.resolve();
    }, ms);

    return dfd.promise();
  }

  function promiseAllSettled(promises) {
    var reflect = function(promise) {
      return promise.then(
        function(value) {
          return {status: 'fulfilled', value: value};
        },
        function(error) {
          return {status: 'rejected', reason: error};
        },
      );
    };

    return Promise.all(promises.map(reflect));
  }

  window.chain_promises = chain_promises;
  window.sleep = sleep;
  window.promiseAllSettled = promiseAllSettled;
})();

(function() {
  // functions for tests

  /**
   * Обёртка для jQ Deferred, которая всегда резолвится, но при реджекте внутреннего промиса резолвится объектом со
   * свойством error удобно использовать в $.when
   * @param {Deferred.promise} promise
   * @returns {Deferred.promise}
   */
  function wrap_promise(promise) {
    var d = $.Deferred();
    promise
      .done(function(data) {
        d.resolve(data);
      })
      .fail(function(err) {
        d.resolve({error: err});
      });
    return d.promise();
  }

  function get_file(url) {
    var d = $.Deferred();
    var oReq = new XMLHttpRequest();
    oReq.open('GET', url, true);
    oReq.responseType = 'arraybuffer';
    oReq.onload = function(oEvent) {
      d.resolve(oReq.response);
    };
    oReq.onerror = function() {
      d.reject();
    };
    oReq.send();
    return d.promise();
  }

  function humanize(size) {
    var units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
    var ord = Math.floor(Math.log(size) / Math.log(1024));
    ord = Math.min(Math.max(0, ord), units.length - 1);
    var s = Math.round((size / Math.pow(1024, ord)) * 100) / 100;
    return s + ' ' + units[ord];
  }

  window.wrap_promise = wrap_promise;
  window.get_file = get_file;
  window.humanize = humanize;
})();

(function() {
  function _arrayBufferToBase64(buffer) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return 'data:image;base64,' + btoa(binary);
  }

  window._arrayBufferToBase64 = _arrayBufferToBase64;
})();

(function() {
  // import structv2  equals  isset

  var manageBodyClasses = (function() {
    var prevClasses = [];
    return function(pageId) {
      pageId = getPageId(pageId);
      var classes = getClasses(structv2.pages[pageId]);

      if (equals(prevClasses, classes)) {
        return false;
      }

      prevClasses.map(function(c) {
        document.body.classList.remove(c);
      });
      classes.map(function(c) {
        document.body.classList.add(c);
      });

      prevClasses = classes;
    };

    function getPageId(id) {
      if (id === '#shopitem') {
        var page = document.getElementById('shopitem');
        id = page.getAttribute('itemid');
      }

      return 'id_' + id.replace('#', '');
    }

    function getClasses(page) {
      var result = [];

      // почему-то у Магазина есть imageWide
      if (!page || !page.imageWide || page.type === 'shop' || page.type === 'list') {
        return result;
      }

      result.push(isset('config.tv.page_type', 'standard'));

      return result;
    }
  })();

  window.manageBodyClasses = manageBodyClasses;
})();

(function() {
  // todo replace with deep clone

  function copyArr(arr) {
    var a = [];
    for (var i = 0; i < arr.length; i++) {
      a.push(Object.assign({}, arr[i]));
    }
    return a;
  }

  window.copyArr = copyArr;
})();

(function() {
  // TODO move into components service ?

  // import getPageFromStruct

  function getParent(page, depth) {
    if (depth === 0) {
      return page;
    }

    return getParent(getPageFromStruct(page.parentId), --depth);
  }

  /**
   * Returns the parent page that has a menu as a parent
   * */
  function getGrandParentPage(pageId) {
    var page = getPageFromStruct(pageId);
    if (page.backBtn === 0) {
      return page;
    }

    return getGrandParentPage(page.parentId);
  }

  function getParentPage(pageId) {
    return getPageFromStruct(getPageFromStruct(pageId).parentId);
  }

  /**
   * Возвращает всех потомков (pages) -1.
   * Если -1 - это сама страница, то возвращаем потомка
   * */
  function getGrandChildren(pageId) {
    var page = getPageFromStruct(pageId);
    var ids = [];
    var outputIds = [];
    var parents = [];

    getChildrenIds(page);
    getChildrenParents(ids);

    return parents;

    function getChildrenIds(page) {
      if (page.type === 'page' || page.type === 'video') {
        ids.push(page.id);
      }

      if (page.listItems) {
        var listItems = Object.keys(page.listItems).map(function(key) {
          return page.listItems[key];
        });
        for (var i = 0; i < listItems.length; i++) {
          var child = listItems[i];
          getChildrenIds(getPageFromStruct(child.id));
        }
      }
    }

    function getChildrenParents(ids) {
      if (ids.length === 0) {
        return true;
      }

      var id = ids.splice(0, 1)[0];
      var parent = getParent(getPageFromStruct(id), 1);
      if (parent.id === pageId) {
        parent = getPageFromStruct(id);
      }

      if (outputIds.indexOf(parent.id) === -1) {
        parents.push(parent);
        outputIds.push(parent.id);
      }

      return getChildrenParents(ids);
    }
  }

  /**
   * используется в fullscreenImage
   * потомки List, но не Grand Parent
   * */
  function getSiblings(pageId) {
    var parent = getParent(getPageFromStruct(pageId), 1);
    var grandParent = getGrandParentPage(pageId);

    if (!parent) {
      return {length: 0};
    }
    var parentChildren = parent.listItems || parent.children;
    if ((grandParent && parent.id === grandParent.id) || !parentChildren) {
      return {length: 0};
    }

    var listItems = Object.values(parentChildren)
    var result = {};
    for (var i = 0; i < listItems.length; i++) {
      var listItem = listItems[i];
      listItem.index = i + 1;
      if (listItem.id === pageId) {
        var prevItem = listItems[i - 1] || {};
        var nextItem = listItems[i + 1] || {};

        result.prev = prevItem;
        result.current = listItem;
        result.next = nextItem;
      }
    }

    return {
      length: listItems.length,
      listItems: result,
    };
  }

  /**
   * Get a list of all page siblings (listItems or children with the same parent)
   * @param {string} pageId
   * @return {{length: number, listItems?: {}}}
   */
  function getPageSiblings(pageId) {
    var parent = getParentPage(pageId);
    if (parent) {
      return Object.values(parent.listItems || parent.children || {});
    }
    return [];
  }

  window.getParent = getParent;
  window.getGrandParentPage = getGrandParentPage;
  window.getParentPage = getParentPage;
  window.getPageSiblings = getPageSiblings;
  window.getGrandChildren = getGrandChildren;
  window.getSiblings = getSiblings;
})();

(function() {
  // import getPageFromStruct isset getGrandParentPage navigate $ tv_cur_elem tv_cur_pos tv_sel_list setPositionTvCur

  function getBreadcrumbId(pageId) {
    var page = getPageFromStruct(pageId);
    if (page.listItems) {
      var listItems = Object.keys(page.listItems).map(function(key) {
        return page.listItems[key];
      });
      if (listItems.length) {
        return listItems[0].id;
      }
    }

    return pageId;
  }

  function isBreadcrumbShow(pageId) {
    if (!pageId) {
      return false;
    }

    var enabledPages = isset('config.tv.ui.breadcrumbs_enabled_pages', []);
    if (enabledPages.length === 0) {
      return false;
    }

    var grandParent = getGrandParentPage(pageId);
    return enabledPages.indexOf(grandParent.id) !== -1;
  }

  function breadcrumbNavigate(pageId) {
    var pageHref = '#' + pageId;
    var breadcrumbByIdQuery = '[data-breadcrumb-id="' + pageId + '"]';

    navigate(pageHref, null, true).done(function() {
      var prevActive = $('[data-breadcrumb-id].active');
      var nextActive = $(breadcrumbByIdQuery);

      prevActive.removeClass('active');
      nextActive.addClass('active');

      tv_cur_elem = $('#' + pageId + ' ' + breadcrumbByIdQuery);
      tv_cur_pos = tv_sel_list.index(tv_cur_elem);

      setPositionTvCur();
    });
  }

  window.getBreadcrumbId = getBreadcrumbId;
  window.isBreadcrumbShow = isBreadcrumbShow;
  window.breadcrumbNavigate = breadcrumbNavigate;
})();

(function() {
  // import
  // navigate
  // tv_cur_elem
  // tv_cur_pos
  // tv_sel_list
  // setPositionTvCur

  function executePageNavigation(pageId) {
    navigate('#' + pageId, null, true).done(function() {
      tv_cur_elem = $('#' + pageId).find('.page-navigator');
      tv_cur_pos = tv_sel_list.index(tv_cur_elem);

      setPositionTvCur();
    });
  }

  window.executePageNavigation = executePageNavigation;
})();

(function() {
  // import Guest tv_room get_language

  function interpolateUrl(template) {
    var map = {
      reservationid: Guest.pmsNum,
      roomnumber: tv_room,
      guestlanguage: get_language(),
      pmsnum: Guest.pmsNum,
      firstname: Guest.guestName,
      guestname: Guest.guestName,
      lastname: Guest.guestSurname,
      guestsurname: Guest.guestSurname,
    };

    var clean = template.replace(/\{(\w+)\}/g, function(_, key) {
      var value = map[key.toLowerCase()];
      if (value == null || value === '') return 'null';
      return encodeURIComponent(value);
    });

    clean = clean.replace(/([^:]\/)\/+/g, '$1');

    return {result: clean, reason: null};
  }

  window.interpolateUrl = interpolateUrl;
})();

(function() {
  // import interpolateUrl tv_launch_third_party_app

  function tv_handle_third_party_link(linkTemplate) {
    var interp = interpolateUrl(linkTemplate);
    if (!interp.result) {
      console.warn('[third_party_link] cannot open, missing:', interp.reason, 'interp result: ', interp.result);
      return;
    }
    tv_launch_third_party_app(interp.result);
  }

  window.tv_handle_third_party_link = tv_handle_third_party_link;
})();

(function() {
  // TODO refactor to QR code service

  // import
  // interpolateUrl
  // HotezaTV
  // $
  // isset
  // config

  function getQrUrl(qrCodeData) {
    var urlKeyValue = null;
    var output = {
      result: null,
      reason: null,
    };

    if (!qrCodeData || !qrCodeData.type) {
      output.reason = 'invalid qrCodeData object';
      return output;
    }

    switch (qrCodeData.type) {
      case 'room':
        if (!qrCodeData.urls || typeof qrCodeData.urls !== 'object') {
          output.reason = 'invalid room.urls';
          return output;
        }
        urlKeyValue = tv_room;
        output.result = qrCodeData.urls[urlKeyValue] || null;
        break;

      case 'insert':
        if (!qrCodeData.url || typeof qrCodeData.url !== 'string') {
          output.reason = 'missing insert.url';
          return output;
        }
        return interpolateUrl(qrCodeData.url);

      // 	использовать для запросов к сторонним ресурсам
      // case 'execute':
      // 	break;
    }

    return output;
  }

  function showQrCode(pageId) {
    var qrCode = getQrCode(pageId);
    var qrUrl = getQrUrl(qrCode);
    var qrCodeImage = $('#' + pageId + ' .dynamic-qr-code canvas');

    if (qrUrl.result === null) {
      if (qrUrl.reason) {
        // the method to sub on value update
        $(HotezaTV).one(qrUrl.reason + 'Updated', function() {
          showQrCode(pageId);
        });
      }

      return '';
    }

    if (qrCodeImage.length) {
      return '';
    }

    // таймаут, чтобы успел загрузится jquery.qrcode.js
    // а также построится страница запустившая эту функцию
    var qrPlaceholder = $('#' + pageId + ' .dynamic-qr-code');
    if (qrPlaceholder.length === 0 || typeof qrPlaceholder.qrcode === 'undefined') {
      setTimeout(function() {
        showQrCode(pageId);
      }, 1000);

      return '';
    }

    qrPlaceholder.qrcode(qrUrl.result);
  }

  function isDynamicQr(pageId) {
    var qrCode = getQrCode(pageId);

    return !!qrCode;
  }

  function getQrCode(pageId) {
    if (isset('config.dynamicQr', []).length === 0) {
      return null;
    }

    for (var i = 0; i < config.dynamicQr.length; i++) {
      var qrElement = config.dynamicQr[i];
      if (qrElement.pageId === pageId) {
        return qrElement;
      }
    }

    return null;
  }

  window.getQrCode = getQrCode;
  window.getQrUrl = getQrUrl;
  window.showQrCode = showQrCode;
  window.isDynamicQr = isDynamicQr;
})();

(function() {
  // import $

  function setActiveNavItem(pageId) {
    $('.active-nav-item').removeClass('active-nav-item');
    $('[href$="' + pageId + '"]').addClass('active-nav-item');
  }

  window.setActiveNavItem = setActiveNavItem;
})();

(function() {
  // import wakeup_status

  function removeWakeupStatus() {
    wakeup_status(false, null, null);
  }

  window.removeWakeupStatus = removeWakeupStatus;
})();

(function() {
  // refactor to scroll service
  // $
  // HotezaTV
  // tv_cur_pos
  // tv_sel_list
  // tv_sel_cur

  function scrollToElement(pageId, anchor) {
    $('#tv_cur').hide();
    $(HotezaTV).one('finish_animate', function() {
      var targetItem = document.querySelector('[data-anchor="' + anchor + '"]');
      var firstSelectable = targetItem.querySelector('[selectable]');
      tv_cur_pos = tv_sel_list.index(firstSelectable);
      setTimeout(tv_sel_cur, 0);
    });
    scrollToAnchor(pageId, anchor);
  }

  function scrollToAnchor(pageId, anchor) {
    var container = document.querySelector('#' + pageId + ' .content');
    var wrapper = document.querySelector('#' + pageId + ' .content_wrapper');

    if (!container || !wrapper) return;

    var targetItem = container.querySelector('[data-anchor="' + anchor + '"]');
    if (!targetItem) return;

    var wrapperRect = wrapper.getBoundingClientRect();
    var targetRect = targetItem.getBoundingClientRect();
    var containerRect = container.getBoundingClientRect();

    // Текущее значение top (если не задано, то 0)
    var currentTop = parseInt(container.style.top, 10) || 0;

    // Вычисляем новое значение top
    var newTop = currentTop - (targetRect.top - wrapperRect.top);

    // Учитываем нижнюю границу: если последний элемент уходит за пределы wrapper
    var maxTop = wrapperRect.height - containerRect.height;
    if (newTop < maxTop) {
      newTop = maxTop;
    }

    // Плавный скролл
    animateScroll(container, currentTop, newTop);
  }

  function animateScroll(container, start, end) {
    if (!container) return;
    var duration = 300;
    var startTime = performance.now();

    function step(currentTime) {
      if (!container) return;

      var elapsed = currentTime - startTime;
      var progress = Math.min(elapsed / duration, 1);
      var ease = progress < 0.5 ? 2 * progress * progress : -1 + (4 - 2 * progress) * progress;

      container.style.top = start + (end - start) * ease + 'px';

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        $(HotezaTV).trigger('finish_animate');
        container.style.top = end + 'px';
      }
    }

    requestAnimationFrame(step);
  }

  window.scrollToElement = scrollToElement;
})();

(function() {
  function hideApp() {
    document.body.style.display = 'none';
  }

  function showApp() {
    document.body.style.display = '';
  }

  window.hideApp = hideApp;
  window.showApp = showApp;
})();

(function() {
  // todo move to function extensions

  function throttle(fn, limit) {
    if (!limit) {
      limit = 500;
    }

    var lastCall = 0;

    return function() {
      var now = Date.now();

      if (now - lastCall >= limit) {
        lastCall = now;
        return fn.apply(this, arguments);
      }
    };
  }

  window.throttle = throttle;
})();

(function() {
  function getHdmiPortNumber(physicalAddressBytes) {
    // physicalAddressBytes — массив из 2 байт, например: [0x10, 0x00]
    var a = (physicalAddressBytes[0] & 0xf0) >> 4;
    // В случае прямого подключения к ТВ: A = номер HDMI-порта
    return a === 0 ? null : a;
  }

  window.getHdmiPortNumber = getHdmiPortNumber;
})();

(function() {
  // Пример:
  // const cecData = "4f821000";
  function parseCecData(dataHex) {
    var bytes = dataHex.match(/.{2}/g).map(function(x) {
      return parseInt(x, 16);
    });
    return {
      opcode: bytes[1],
      params: bytes.slice(2),
    };
  }

  window.parseCecData = parseCecData;
})();

(function() {
  // import
  // isset
  // parental_lock_status
  // custom_input
  // getlang
  // pincode

  function parentalLockCheck(contentTypes) {
    contentTypes = contentTypes || [];

    var d = $.Deferred(),
      needPin = isset('config.tv.parental_lock') && parental_lock_status() && contentTypes.indexOf('xxx') !== -1;

    if (!needPin) {
      d.resolve();
      return d.promise();
    }

    try {
        _tv_channel_stop();
    } catch (e) {
        console.warn("Can't stop channel:", e);
    }

    custom_input({
      title: getlang('parental_lock'),
      text: getlang('parental_lock_confirm'),
      cancel: getlang('cancel'),
      check: pincode(),
      onConfirm: function() {
        d.resolve();
      },
      onCancel: function() {
        d.reject();
      },
    });

    return d.promise();
  }

  window.parentalLockCheck = parentalLockCheck;
})();

(function() {
  function isObjectDefined(obj) {
    return obj !== null && typeof obj !== 'undefined';
  }

  window.isObjectDefined = isObjectDefined;
})();

(function() {
  /**
   * Gets the inherited bottom styles from the element
   *
   * @param {HTMLElement} element - The element to calculate bottom styles for.
   * @returns {string} CSS string containing position and bottom styles.
   */
  function getInheritedBottomStyles(element) {
    element = $(element)[0];
    var elementRect = element.getBoundingClientRect();
    var parentRect = element.parentElement.getBoundingClientRect();

    var bottomDifference = parentRect.bottom - elementRect.bottom;

    return 'position: absolute; bottom: ' + bottomDifference + 'px;';
  }

  /**
   * MarqueeService provides a utility for applying a marquee (scrolling text) effect to DOM elements
   * whose text content exceeds their container width.
   *
   * @namespace MarqueeService
   * @property {Object} CSS_CLASSES - CSS class names used for marquee states and containers.
   * @property {Array<Object>} marqueeElements - List of currently active (processed) marquee elements and their
   *   configs.
   * @property {number|null} interval - Reference to the interval timer for periodic marquee checks.
   * @property {boolean} initialized - Indicates if the service has been initialized.
   * @property {number} intervalTime - Interval time in milliseconds for checking/activating marquees.
   * @property {Array<Object>} dict - Configuration array for different marquee targets and their options.
   *
   * @method init Initializes the MarqueeService and starts checks for activating/deactivating marquees.
   */
  var MarqueeService = {
    CSS_CLASSES: {
      MARQUEE_ACTIVE: 'marquee-active',
      MARQUEE_PROCESSED: 'marquee-processed',
      MARQUEE_TITLE_CONTAINER: 'marquee-title-container',
    },
    marqueeElements: [],
    interval: null,
    initialized: false,
    intervalTime: 500,
    /**
     * @typedef {Object} MarqueeConfigItem
     *
     * Configuration object for a single marquee element.
     * Defines how and when to apply the marquee effect to a specific DOM element.
     *
     * @property {function(): jQuery} element - A function that returns one or more jQuery elements to apply the
     *   marquee effect to.
     * @property {string} titleSelector - CSS selector for the title/text element inside the container that will be
     *   animated.
     * @property {(string|function(jQuery): string|Array<function(jQuery): string>)} [additionalStyles] - Optional
     *   additional styles for the title container. Can be a string of CSS, a function returning styles based on the
     *   title element, or an array of such functions.
     * @property {number} [speed] - Animation speed in pixels per second. If not specified, falls back to config or
     *   default value (80).
     * @property {number} [gap] - Gap between duplicated text parts in pixels. Falls back to config or default (50).
     * @property {number} [delay] - Delay before animation starts in milliseconds. Falls back to config or default
     *   (1000).
     * @property {function(jQuery): boolean} [deactivateCondition] - Function that determines if the marquee should be
     *   deactivated. Takes a jQuery element and returns true if the marquee should be deactivated, false otherwise.
     */
    /**
     * @type {Array<MarqueeConfigItem>}
     *
     * The `dict` array contains configurations for different types of elements
     * that may require a marquee animation.
     *
     * Each entry defines:
     * - Which DOM elements to target
     * - Which child element contains the text to animate
     * - Custom styling and animation settings
     * - Conditions under which the marquee should be deactivated
     */
    dict: [
      {
        element: function() {
          return $('.custom_information_page.active_page .header');
        },
        titleSelector: 'h1',
        additionalStyles: undefined,
        speed: undefined,
        gap: undefined,
        delay: undefined,
        deactivateCondition: function($element) {
          return !$element.parents('.active_page').length;
        },
      },
      {
        element: function() {
          return $(active_page + ' .information-list-hub__list-item.tv_cur');
        },
        titleSelector: '.information-list-hub__list-item__title',
        additionalStyles: getInheritedBottomStyles,
        speed: undefined,
        gap: undefined,
        delay: undefined,
        deactivateCondition: function($element) {
          return !$element.hasClass('tv_cur') || !$element.parents('.active_page').length;
        },
      },
      {
        element: function() {
          return $(active_page + ' .tv_channel_name').closest('li.tv_cur');
        },
        titleSelector: '.tv_channel_name',
        additionalStyles: 'width: 150px; overflow: hidden;',
        speed: undefined,
        gap: undefined,
        delay: undefined,
        deactivateCondition: function($element) {
          return !$element.hasClass('tv_cur') || !$element.parents('#tv_mosaic').length;
        },
      },
    ],
    init: function() {
      if (MarqueeService.initialized) return;

      MarqueeService.startMarqueeCheck();

      MarqueeService.initialized = true;
    },

    /**
     * Starts the check for marquee activation/deactivation.
     *
     * Currently implemented using setInterval to periodically check and manage marquee elements.
     *
     * TODO: Consider implementing event-based approach by listening to page navigation events
     * instead of using intervals. This could be more efficient and responsive to actual
     * page changes rather than constant polling.
     *
     * @private
     */
    startMarqueeCheck: function() {
      MarqueeService.interval = setInterval(function() {
        if (MarqueeService.marqueeElements.length > 10) {
          log.add(
            'MarqueeService: marqueeElements contains more than 10 objects:',
            MarqueeService.marqueeElements.length,
          );
        }

        MarqueeService.deactivateIrrelevantMarquee();
        MarqueeService.activateMarquee();
      }, MarqueeService.intervalTime);
    },
    activateMarquee: function() {
      for (var i = 0; i < MarqueeService.dict.length; i++) {
        var item = MarqueeService.dict[i];
        var $elements = item.element();
        for (var j = 0; j < $elements.length; j++) {
          var $element = $($elements[j]);
          if (!$element.hasClass(MarqueeService.CSS_CLASSES.MARQUEE_PROCESSED)) {
            MarqueeService.processElement(
              $element,
              item.titleSelector,
              item.additionalStyles,
              item.speed,
              item.gap,
              item.delay,
            );
            MarqueeService.marqueeElements.push({
              element: $element,
              titleSelector: item.titleSelector,
              additionalStyles: item.additionalStyles,
              speed: item.speed,
              gap: item.gap,
              delay: item.delay,
              deactivateCondition: item.deactivateCondition,
            });
          }
        }
      }
    },
    deactivateIrrelevantMarquee: function() {
      MarqueeService.marqueeElements = MarqueeService.marqueeElements.filter(function(obj) {
        var $element = obj.element;
        if ($element.length && obj.deactivateCondition && obj.deactivateCondition($element)) {
          MarqueeService.disable($element[0], obj.titleSelector);
          return false;
        }
        return true;
      });
    },

    /**
     * Processes a suitable element and applies the marquee effect if the text is too wide for the container.
     * Adds the marquee-processed class to indicate the element has been processed.
     *
     * @param {HTMLElement} element - HTML element containing text.
     * @param {string} titleClassSelector - Title class selector inside the element.
     * @param {(function|string)} [titleContainerAdditionalStyles] - Additional CSS styles for the title container. Can
     *   be a string of CSS styles or a function that returns styles based on the title element.
     * @param {number} speed - The speed of animation.
     * @param {number} gap - The distance between duplicated parts of the text.
     * @param {number} delay - Delay in ms
     */
    processElement: function(element, titleClassSelector, titleContainerAdditionalStyles, speed, gap, delay) {
      speed = typeof speed === 'number' ? speed : isset('config.tv.marquee.speed', 80);
      gap = typeof gap === 'number' ? gap : isset('config.tv.marquee.gap', 50);
      delay = typeof delay === 'number' ? delay : isset('config.tv.marquee.delay', 1000);

      var $element = $(element);
      if ($element.hasClass(MarqueeService.CSS_CLASSES.MARQUEE_PROCESSED)) {
        return;
      }

      $element.addClass(MarqueeService.CSS_CLASSES.MARQUEE_PROCESSED);

      var $title = $element.find(titleClassSelector);
      if (!$title.length) {
        return;
      }

      var $firstTitle = $title.first();

      var textWidth = getTextWidth($firstTitle);
      var containerWidth = $element.width();

      if (textWidth <= containerWidth) {
        return;
      }

      // Make it for smooth scrolling
      makeDoubleText($element, titleClassSelector, titleContainerAdditionalStyles, gap);
      var $titles = $element.find(titleClassSelector);
      startScrollAnimation($titles, textWidth, gap, speed, delay);

      $element.addClass(MarqueeService.CSS_CLASSES.MARQUEE_ACTIVE);

      /**
       * Returns the width of the text of the element.
       *
       * @param {jQuery} $element - An element whose text width will be measured.
       * @returns {number} The width of the text in pixels.
       */
      function getTextWidth($element) {
        var $clone = $element
          .clone()
          .css({
            position: 'absolute',
            visibility: 'hidden',
            width: 'auto',
            whiteSpace: 'nowrap',
            display: 'inline-block',
          })
          .appendTo($element.parent());
        var computedStyle = window.getComputedStyle($element[0]);

        var paddingLeft = parseFloat(computedStyle.paddingLeft);
        var paddingRight = parseFloat(computedStyle.paddingRight);
        var marginLeft = parseFloat(computedStyle.marginLeft);
        var marginRight = parseFloat(computedStyle.marginRight);

        var width = $clone.width() + paddingLeft + paddingRight + marginLeft + marginRight;

        $clone.remove();
        return width;
      }

      /**
       * Creates two identical headings inside the container for seamless scrolling.
       *
       * @param {jQuery} $element - The element in which titles are created.
       * @param {string} titleClassSelector - Title class selector
       * @param {(function|string)} titleContainerAdditionalStyles - Additional styles
       * @param {number} gap - Gap between duplicated text
       */
      function makeDoubleText($element, titleClassSelector, titleContainerAdditionalStyles, gap) {
        var $title = $element.find(titleClassSelector);
        if ($title.length === 0) {
          return false;
        }

        if (typeof titleContainerAdditionalStyles === 'function') {
          titleContainerAdditionalStyles = titleContainerAdditionalStyles($title);
        } else if (Array.isArray(titleContainerAdditionalStyles)) {
          var calculatedTitleContainerAdditionalStyles = '';
          titleContainerAdditionalStyles.forEach(function(additionalStyle) {
            if (typeof additionalStyle === 'function') {
              calculatedTitleContainerAdditionalStyles += additionalStyle($title) + ';';
            }
          });
          titleContainerAdditionalStyles = calculatedTitleContainerAdditionalStyles;
        }
        titleContainerAdditionalStyles = titleContainerAdditionalStyles || '';

        var $newTitleContainer = $('<div>')
          .attr('style', titleContainerAdditionalStyles)
          .css({
            display: 'flex',
          })
          .addClass(MarqueeService.CSS_CLASSES.MARQUEE_TITLE_CONTAINER);

        var originalTagName = $title.prop('tagName');
        var titleText = $title.text().trim();

        var $newTitle = $('<' + originalTagName + '>')
          .addClass(titleClassSelector.replace('.', ''))
          .text(titleText)
          .attr('style', 'position: static;')
          .css({
            overflow: 'visible',
            textOverflow: 'clip',
            whiteSpace: 'nowrap',
            display: 'inline-block',
            flexShrink: 1,
            marginRight: gap + 'px',
          });

        var $newTitleClone = $newTitle.clone();

        $newTitleContainer.append($newTitle);
        $newTitleContainer.append($newTitleClone);

        $title.replaceWith($newTitleContainer);
      }

      /**
       * Starts the scroll animation for marquee effect
       *
       * @param {jQuery} $titles - jQuery object containing title elements
       * @param {number} textWidth - Width of the text
       * @param {number} gap - Gap between duplicated text
       * @param {number} speed - Animation speed
       * @param {number} delay - Delay before animation starts
       */
      function startScrollAnimation($titles, textWidth, gap, speed, delay) {
        var position = 0;
        var distance = textWidth + gap;

        function animate() {
          position -= speed / 60;

          if (position <= -distance) {
            position = 0;

            setTimeout(function() {
              requestAnimationFrame(animate);
            }, delay);
          } else {
            $titles.css({
              transform: 'translate3d(' + position + 'px, 0, 0)',
            });

            requestAnimationFrame(animate);
          }
        }

        setTimeout(function() {
          requestAnimationFrame(animate);
        }, delay);
      }
    },
    /**
     * Disables the effect of Marquee and restores the original text.
     *
     * @param {HTMLElement} element - HTML element containing text.
     * @param {string} titleClassSelector - Title class inside the element.
     */
    disable: function(element, titleClassSelector) {
      var $element = $(element);

      var $titles = $element.find(titleClassSelector);
      if (!$titles.length) {
        return;
      }

      var originalText = $titles.first().text();
      var originalTagName = $titles.first().prop('tagName');
      var $newTitle = $('<' + originalTagName + '>')
        .addClass(titleClassSelector.replace('.', ''))
        .text(originalText);

      var $marqueeContainer = $element.find('.' + MarqueeService.CSS_CLASSES.MARQUEE_TITLE_CONTAINER);
      $marqueeContainer.replaceWith($newTitle);

      $element.removeClass(MarqueeService.CSS_CLASSES.MARQUEE_ACTIVE);
      $element.removeClass(MarqueeService.CSS_CLASSES.MARQUEE_PROCESSED);
    },
    destroy: function() {
      if (MarqueeService.interval) {
        clearInterval(MarqueeService.interval);
        MarqueeService.interval = null;
      }
      for (var i = 0; i < MarqueeService.marqueeElements.length; i++) {
        var obj = MarqueeService.marqueeElements[i];
        MarqueeService.disable(obj.element[0], obj.titleSelector);
      }
      MarqueeService.marqueeElements = [];
      MarqueeService.initialized = false;
    },
  };

  window.getInheritedBottomStyles = getInheritedBottomStyles;
  window.MarqueeService = MarqueeService;
})();



(function() {
  // todo replace with Array.find()
  function findInArray(arr, predicate) {
    if (typeof predicate !== 'function') {
      throw new TypeError('predicate must be a function');
    }

    var len = arr.length >>> 0;

    for (var i = 0; i < len; i++) {
      var value = arr[i];
      if (predicate(value, i, arr)) {
        return value;
      }
    }

    return undefined;
  }

  window.findInArray = findInArray;
})();

(function() {
  function hideOverlay() {
    $('#tv_fullscreen_overlay').hide();
  }

  function showOverlay() {
    $('#tv_fullscreen_overlay').show();
  }

  window.hideOverlay = hideOverlay;
  window.showOverlay = showOverlay;
})();
